import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { formatQueryInput } from '../../../../../utils/formatQueryInput';

export function QueryInputTooltipContent({ input, queryTypeCode }) {
	const entries = useMemo(() => formatQueryInput(input, queryTypeCode), [input, queryTypeCode]);

	if (entries.length === 0) return null;

	return (
		<div className="w-64 bg-gray-800 text-white rounded-lg shadow-xl px-3 py-2.5 text-xs text-left">
			<h4 className="text-[10px] font-semibold text-bgBase-600 uppercase tracking-wide mb-2">Suchkriterien</h4>
			<div className="space-y-1.5">
				{entries.map((entry, i) => (
					<div key={i} className="text-left">
						<span className="text-[10px] text-bgBase-600">{entry.label}</span>
						<div className="mt-px">
							{entry.type === 'tags' ? (
								<div className="flex flex-wrap gap-0.5">
									{entry.value.map((tag, j) => (
										<span
											key={j}
											className="inline-block px-1.5 py-px text-[11px] bg-gray-700 rounded text-white"
										>
											{tag}
										</span>
									))}
								</div>
							) : entry.type === 'boolean' ? (
								<span className={`text-[11px] font-medium`}>{entry.value ? 'Ja' : 'Nein'}</span>
							) : (
								<span className="text-[11px] text-white">{entry.value}</span>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

QueryInputTooltipContent.propTypes = {
	input: PropTypes.object,
	queryTypeCode: PropTypes.string,
};
